
import { Component, Mixins } from "vue-property-decorator";
import { IScriptGroupKeyPropertyEditable, instanceOfIScriptGroupKeyPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class ScriptGroupKeyPropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IScriptGroupKeyPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IScriptGroupKeyPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isScriptGroupKeyEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIScriptGroupKeyPropertyEditable(s) && s.scriptGroupKey().isEditable(), false);
  }

  get scriptGroupKey(): string {
    return this.readPropertyOrDefault(s => s.scriptGroupKey().getValue(), "");
  }

  set scriptGroupKey(value: string) {
    this.writePropertyWhenValid(s => s.scriptGroupKey().setValue(value));
  }
}
